import CoursePostModal from "./course-post-modal.vue";
export default CoursePostModal;
